import { PATHS } from '../../../routes';

import { ExamCompletedSection } from './containers';

function Completed() {
  return (
    <div className='flex h-full w-full items-center'>
      <ExamCompletedSection />
    </div>
  );
}

const CompletedRoute = {
  path: PATHS.Exam.Completed,
  element: <Completed />,
};

export default CompletedRoute;
